'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import type { ProjectReference } from '@/types/project-reference';
import { CompactSection, ContextCount } from './section-components';

interface ProjectReferencesSectionProps {
  references: ProjectReference[] | undefined;
  isLoading: boolean;
  projectId: string;
  onEdit?: () => void;
}

export function ProjectReferencesSection({
  references,
  projectId,
  onEdit,
}: ProjectReferencesSectionProps) {
  const t = useTranslations('project');

  const completedRefs = useMemo(
    () =>
      references?.filter(
        (r) => r.attributes.classification_status === 'completed'
      ) || [],
    [references]
  );

  return (
    <CompactSection
      title={t('references')}
      href={`/project/${projectId}/references`}
      onClick={onEdit}
      contextContent={
        completedRefs.length > 0 ? (
          <ContextCount count={completedRefs.length} />
        ) : undefined
      }
    />
  );
}
